export function formataCelularMask(value: string) {
  const apenasNumeros = value.replace(/\D/g, ''); // Remove caracteres não numéricos
  const tamanho = apenasNumeros.length;

  if (tamanho <= 2) return apenasNumeros;
  if (tamanho <= 6) return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2)}`;
  if (tamanho <= 7 && value.includes('-')) return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2)}`;
  return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7, 11)}`;
}
